// import React, { useEffect, useRef } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { useReactToPrint } from "react-to-print";
// import "./LiveOrder.css";
// import { fetchLiveOrder, updateOrderStatus,fetchLiveOrderByTableOtp } from "../../redux/action";
// import { OrderStatus } from "../../Utills/enums";
// import PrintKot from "../../component/PrintKOT/PrintKOT";


// const LiveOrder = ({ tableOtp }) => {
//   const dispatch = useDispatch();
//   const kotRef = useRef();
//   const orderList = useSelector((state) => state.admin.liveOrder);

//   const handleKotPrint =  useReactToPrint ({
//            contentRef: kotRef,
//         });

//  useEffect(() => {
//   console.log("fetchLiveOrder", orderList);

//   if (tableOtp !== undefined && tableOtp !== null) {
//     dispatch(fetchLiveOrderByTableOtp(tableOtp)); // ✅ fetch specific table
//   } else {
//     dispatch(fetchLiveOrder()); // ✅ fetch all tables
//   }
// }, [dispatch, tableOtp]);


//   console.log("orderList", orderList);

//   if (!orderList || orderList.length === 0) {
//     return <p>No data found...</p>;
//   }



//   return (
//     <div className="order-list">
//       {Array.isArray(orderList) &&
//         orderList.map((order, idx) => {
//           // ✅ Pick one status (first item’s status)
//           const firstStatus = order.orders?.[0]?.status;
//           const orderDateTime = order.orders?.[0]?.orderDateTime;
//           const orderIds = order.orders?.map(item => item.orderId) || [];
//           // ✅ Create a ref for this order
//         //  const kotRef = useRef();

//         // ✅ Hook must be called here, not inside a function
//         //    const handleKotPrint = useReactToPrint({
//         //   content: () => kotRef.current,
//         // });

//           return (
//             <div key={idx} className="order-card">
//               <div className="order-header">
//                 <span className="order-id">Order #{order.orderNumber}</span>
//                 <span className="status served">{orderDateTime}</span>

//                 {firstStatus !== undefined && (
//                   <div
//                     className={`status ${OrderStatus[firstStatus].toLowerCase()}`}
//                   >
//                     {OrderStatus[firstStatus]}
//                   </div>
//                 )}
//               </div>

//               <div className="order-body">

//                 <p>
//                   <span className="print-btn" onClick={handleKotPrint}>
//                    <span role="img" aria-label="print">🖨️</span>
//                    <span className="tooltip">Print KOT</span>
//                   </span>
//                    <strong>Table:</strong> {order.tableNumber}
//                 </p>
//                 <table className="items-table">
//                   <thead>
//                     <tr>
//                       <th>Item</th>
//                       <th>Qty</th>
//                       <th>Cancel</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {Array.isArray(order.orders) &&
//                       order.orders.map((item, i) => (
//                         <tr key={i}>
//                           <td>{item.foodName}</td>
//                           <td>{item.qty}</td>
//                           <td>
//                             <span
//                               className="link-btn danger"
//                               title="Cancel"
//                               aria-label="Delete"
//                               onClick={() =>
//                     dispatch(
//                       updateOrderStatus({
//                         tableNumber: order.tableNumber,
//                         orderIds: orderIds, 
//                         status: "Cancelled",
//                       })
//                     )
//                   }
//                             >
//                               ✖
//                             </span>
//                           </td>
//                         </tr>
//                       ))}
//                   </tbody>
//                 </table>
//               </div>

//               <div className="order-actions">
//                 {/* <button
//                   className="btn-served"
//                   onClick={() =>
//                     dispatch(
//                       updateOrderStatus({
//                         tableNumber: order.tableNumber,
//                         orderIds: orderIds,   // ✅ send all IDs
//                         status: "Served",
//                       })
//                     )
//                   }
//                 >
//                   Mark Served
//                 </button> */}

//                 <button
//                   className="btn-ready"
//                   onClick={() =>
//                     dispatch(
//                       updateOrderStatus({
//                         tableNumber: order.tableNumber,
//                         orderIds: orderIds, 
//                         status: "Ready",
//                       })
//                     )
//                   }
//                 >
//                   Mark Ready
//                 </button>

//                 <button
//                   className="btn-preparing"
//                   onClick={() =>
//                     dispatch(
//                       updateOrderStatus({
//                         tableNumber: order.tableNumber,
//                         orderIds: orderIds, 
//                         status: "Preparing",
//                       })
//                     )
//                   }
//                 >
//                   Mark Preparing
//                 </button>

//                 <button
//                   className="btn-cancel"
//                   onClick={() =>
//                     dispatch(
//                       updateOrderStatus({
//                         tableNumber: order.tableNumber,
//                         orderIds: orderIds, 
//                         status: "Cancelled",
//                       })
//                     )
//                   }
//                 >
//                   Cancel
//                 </button>
//               </div>

//                <div 
//               //  style={{ display: "none" }}
//                >
//                  <PrintKot ref={kotRef} items={order.orders} bill={null} liveOrderKot={true} />
//                </div>
//             </div>
//           );
//         })}
//     </div>
//   );
// };

// export default LiveOrder; ////////////////////////--------------------------///////////////////////////////////






// import React, { useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import "./LiveOrder.css";
// import { fetchLiveOrder, fetchLiveOrderByTableOtp } from "../../redux/action";
// import LiveOrderCard from "./LiveOrderCard";
// import EmptyScreen from "../../component/common/EmptyScreen";

// const LiveOrder = ({ tableOtp }) => {
//   const dispatch = useDispatch();
//   const orderList = useSelector((state) => state.admin.liveOrder);
//   const notifications = useSelector((state) => state.notifications.list);

//   console.log("orderList",orderList)
//   useEffect(() => {
//     if (tableOtp) {
//       dispatch(fetchLiveOrderByTableOtp(tableOtp));
//     } else {
//       dispatch(fetchLiveOrder());
//     }
//   }, [dispatch, tableOtp, notifications.length]);

//   if (!orderList || orderList.length === 0) {
//     return <EmptyScreen message="No live orders found" />
//   }

//   const orderArray = Array.isArray(orderList) ? orderList : Object.values(orderList);

//   return (
//     <div className="order-list">
//       {orderArray.map(order => (
//         <LiveOrderCard key={order.orderNumber} order={order} tableOtp={tableOtp} />
//       ))}
//     </div>
//   );
// };

// export default LiveOrder; 


import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "../../Utills/toast";
import "./LiveOrder.css";
import "../Takeaway/takeaway.css";
import { fetchLiveOrder, fetchLiveOrderByTableOtp, updateOrderStatus, closeGlobalPopup } from "../../redux/action";
import LiveOrderCard from "./LiveOrderCard";
import EmptyScreen from "../../component/common/EmptyScreen";
import ConfirmBox from "../../component/Popup/ConfirmBox";
import TakeawayOrderCard from "../Takeaway/TakeawayOrderCard";
import { getTakeawayOrders, updateTakeawayStatus } from "../Takeaway/takeawayApi";
import { packageMap } from "../../Utills/enums";
import { advancedBillingApi } from "../../services/advancedBillingApi";
import { useTranslation } from "react-i18next";
import { useActionDialog } from "../../component/common/ActionDialog/ActionDialog";

const LiveOrder = ({ tableOtp }) => {
  const { confirmAction } = useActionDialog();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const realtimeRevision = useSelector(state => state.notifications?.ordersRevision || 0);
  const takeawayRevision = useSelector(state => state.notifications?.takeawayRevision || 0);
  const orderList = useSelector((state) => state.admin.liveOrder);
  const user = JSON.parse(localStorage.getItem("admin_token_info") || "{}");
  const plan = packageMap[user?.packageId];
  const showTakeawayKot = !tableOtp && ["Dine-In Classic", "Smart Ultimate"].includes(plan);

  // Single shared state for cancellation confirmation
  const [cancelData, setCancelData] = useState(null);
  const [kotFilter, setKotFilter] = useState("all");
  const [takeawayOrders, setTakeawayOrders] = useState([]);
  const [takeawayBusy, setTakeawayBusy] = useState("");
  const [refundAdjustments, setRefundAdjustments] = useState([]);

  useEffect(() => {
    if (tableOtp) {
      dispatch(fetchLiveOrderByTableOtp(tableOtp));
    } else {
      dispatch(fetchLiveOrder());
    }
  }, [dispatch, tableOtp, realtimeRevision]);

  const loadTakeawayOrders = useCallback(async (silent = false) => {
    if (!showTakeawayKot) return;
    try {
      setTakeawayOrders(await getTakeawayOrders("live"));
    } catch (error) {
      if (!silent) toast.error(error.message);
    }
  }, [showTakeawayKot]);

  useEffect(() => {
    if (!showTakeawayKot) {
      setTakeawayOrders([]);
      return undefined;
    }
    loadTakeawayOrders();
    const timer = setInterval(() => loadTakeawayOrders(true), 15000);
    return () => clearInterval(timer);
  }, [loadTakeawayOrders, showTakeawayKot, takeawayRevision]);

  const loadRefundAdjustments = useCallback((silent = false) => {
    advancedBillingApi.getKotAdjustments().then(setRefundAdjustments)
      .catch(error => { if (!silent) toast.error(error.message); });
  }, []);

  useEffect(() => {
    loadRefundAdjustments();
    const timer = setInterval(() => loadRefundAdjustments(true), 15000);
    return () => clearInterval(timer);
  }, [loadRefundAdjustments, realtimeRevision]);

  const acknowledgeRefundAdjustment = async adjustmentId => {
    try {
      await advancedBillingApi.acknowledgeKotAdjustment(adjustmentId);
      setRefundAdjustments(current => current.filter(item => item.orderItemAdjustmentId !== adjustmentId));
      toast.success("The refund adjustment was marked as reviewed.");
    } catch (error) { toast.error(error.message); }
  };

  const dineInOrders = useMemo(() => (
    Array.isArray(orderList) ? orderList : Object.values(orderList || {})
  ), [orderList]);

  const activeTakeawayOrders = useMemo(() => (
    takeawayOrders.filter((order) => [0, 1, 2].includes(Number(order.status)))
  ), [takeawayOrders]);

  const visibleOrders = useMemo(() => {
    const entries = [
      ...dineInOrders.map((order) => ({
        type: "dinein",
        id: `dinein-${order.tableOtp || order.tableNumber || "table"}-${order.orderNumber}-${(order.orders || [])
          .map(item => item.foodOrderId || item.orderId || `${item.menuId}-${item.orderDateTime || "item"}`)
          .sort().join("-")}`,
        createdAt: order.orders?.[0]?.orderDateTime,
        order
      })),
      ...activeTakeawayOrders.map((order) => ({
        type: "takeaway",
        id: `takeaway-${order.takeawayOrderId}`,
        createdAt: order.createdAt,
        order
      }))
    ];
    return entries
      .filter((entry) => kotFilter === "all" || entry.type === kotFilter)
      .sort((left, right) => new Date(right.createdAt || 0) - new Date(left.createdAt || 0));
  }, [dineInOrders, activeTakeawayOrders, kotFilter]);

  const changeTakeawayStatus = async (order, status) => {
    if (status >= 5) {
      const action = status === 5 ? "cancel" : "reject";
      const confirmed = await confirmAction({
        title: `${status === 5 ? "Cancel" : "Reject"} takeaway order`,
        message: `Are you sure you want to ${action} ${order.tokenNumber}? The order will move to cancellation history.`,
        confirmLabel: status === 5 ? "Cancel order" : "Reject order",
        danger: true,
      });
      if (!confirmed) return;
    }
    setTakeawayBusy(order.takeawayOrderId);
    try {
      await updateTakeawayStatus(order.takeawayOrderId, status);
      toast.success(`Takeaway order ${order.tokenNumber} updated.`);
      await loadTakeawayOrders(true);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setTakeawayBusy("");
    }
  };

  const handleConfirmCancel = () => {
    if (cancelData) {
      dispatch(
        updateOrderStatus({
          tableNumber: cancelData.tableNumber,
          orderIds: cancelData.orderIds,
          status: "Cancelled",
          tableOtp: tableOtp,
        })
      );
      dispatch(closeGlobalPopup());
      setCancelData(null);
    }
  };

  const handleCloseConfirm = () => {
    dispatch(closeGlobalPopup());
    setCancelData(null);
  };

  if (!showTakeawayKot && (!orderList || orderList.length === 0) && refundAdjustments.length === 0) {
    return <EmptyScreen message="No live orders found" />;
  }

  return (
    <div className="live-kot-workspace">
      {refundAdjustments.length > 0 && <section className="refund-kot-adjustments">
        <h2>{t("Refund / cancellation adjustments")}</h2>
        <div className="refund-kot-grid">{refundAdjustments.map(item => <article key={item.orderItemAdjustmentId}>
          <strong>{item.itemName}</strong><span>{t("Cancel quantity")}: {item.quantity}</span>
          <small>{new Date(item.createdAt).toLocaleString()}</small>
          <button type="button" onClick={() => acknowledgeRefundAdjustment(item.orderItemAdjustmentId)}>{t("Acknowledge")}</button>
        </article>)}</div>
      </section>}
      {showTakeawayKot && <div className="live-kot-filter" role="group" aria-label="Filter live KOT orders">
        <div><strong>Live KOT</strong><span>Dine-in and takeaway kitchen orders</span></div>
        <div className="live-kot-filter-buttons">
          <button type="button" className={kotFilter === "all" ? "active" : ""} aria-pressed={kotFilter === "all"} onClick={() => setKotFilter("all")}>All <span>{dineInOrders.length + activeTakeawayOrders.length}</span></button>
          <button type="button" className={kotFilter === "dinein" ? "active" : ""} aria-pressed={kotFilter === "dinein"} onClick={() => setKotFilter("dinein")}>Dine-in KOT <span>{dineInOrders.length}</span></button>
          <button type="button" className={kotFilter === "takeaway" ? "active" : ""} aria-pressed={kotFilter === "takeaway"} onClick={() => setKotFilter("takeaway")}>Takeaway KOT <span>{activeTakeawayOrders.length}</span></button>
        </div>
      </div>}

      {visibleOrders.length === 0 ? <EmptyScreen message={`No ${kotFilter === "all" ? "live" : kotFilter === "dinein" ? "dine-in" : "takeaway"} KOT orders found`} /> : <div className="order-list live-kot-order-list">
        {visibleOrders.map((entry) => entry.type === "dinein" ? (
          <LiveOrderCard
            key={entry.id}
            order={entry.order}
            tableOtp={tableOtp}
            onOpenCancelConfirm={(data) => setCancelData(data)}
          />
        ) : (
          <TakeawayOrderCard
            key={entry.id}
            order={entry.order}
            onStatus={changeTakeawayStatus}
            busy={takeawayBusy === entry.order.takeawayOrderId}
            showBilling={false}
            useKotTableStyle
          />
        ))}
      </div>}

      {/* SINGLE Global ConfirmBox for the whole page */}
      <ConfirmBox
        title={`Are you sure you want to cancel ${cancelData?.label || 'this item'}?`}
        onConfirm={handleConfirmCancel}
        onCancel={handleCloseConfirm}
      />
    </div>
  );
};

export default LiveOrder;


